import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import ApiLogs from '~root/src/webComponents/ApiLogs.vue?shadow'
window.customElements.define('unraid-api-logs', wrap(Vue, ApiLogs))

import Authed from '~root/src/webComponents/Authed.vue?shadow'
window.customElements.define('unraid-authed', wrap(Vue, Authed))

import EventStatus from '~root/src/webComponents/EventStatus.vue?shadow'
window.customElements.define('unraid-event-status', wrap(Vue, EventStatus))

import Launchpad from '~root/src/webComponents/Launchpad.vue?shadow'
window.customElements.define('unraid-launchpad', wrap(Vue, Launchpad))

import Promo from '~root/src/webComponents/Promo.vue?shadow'
window.customElements.define('unraid-promo', wrap(Vue, Promo))

import UpcTrigger from '~root/src/webComponents/UpcTrigger.vue?shadow'
window.customElements.define('unraid-upc-trigger', wrap(Vue, UpcTrigger))

import UserProfile from '~root/src/webComponents/UserProfile.vue?shadow'
window.customElements.define('unraid-user-profile', wrap(Vue, UserProfile))

import WanIpCheck from '~root/src/webComponents/WanIpCheck.vue?shadow'
window.customElements.define('unraid-wan-ip-check', wrap(Vue, WanIpCheck))